import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { SETTINGS_HREF } from '../PageLayout/settings';

/** Where closing settings lands when the modal was opened by its own URL. */
const DEFAULT_BACKGROUND = '/';

/** Pages that exist to be left, so settings never reopen over one. */
const AUTH_PATHS = ['/signin', '/signup'];

/**
 * Whether settings are open, and the page they opened over. Held here rather
 * than in history state, which every plain link inside the panel would drop.
 */
const useSettingsBackground = () => {
  const location = useLocation();

  // Bounded at a path separator, so a route merely starting with the same
  // letters is an ordinary page rather than the settings modal
  const isSettings =
    location.pathname === SETTINGS_HREF || location.pathname.startsWith(`${SETTINGS_HREF}/`);

  const background = useRef(DEFAULT_BACKGROUND);

  useEffect(() => {
    if (!isSettings && !AUTH_PATHS.includes(location.pathname)) {
      background.current = `${location.pathname}${location.search}`;
    }
  }, [isSettings, location]);

  return { isSettings, background: background.current };
};

export default useSettingsBackground;
